import {
    Box,
    Typography,
    Card,
    CardMedia,
    CardContent,

} from "@mui/material"
import React from "react";
import './VideoCard.css';

// var DateDiff = require('date-diff');
import DateDiff from 'date-diff'
import { Link } from "react-router-dom";

export const formatTime = (date)=>{
        const _MS_PER_DAY = 1000 * 60 * 60 * 24;

        let currDate = new Date();
        let videoDate = new Date(date);

        // const utcCurrDate = Date.UTC(currDate.getFullYear(), currDate.getMonth(), currDate.getDate());
        // const utcVideoDate = Date.UTC(videoDate.getFullYear(), videoDate.getMonth(), videoDate.getDate());

        // let diff = Math.floor((utc2 - utc1) / _MS_PER_DAY);
        let diff = new DateDiff(currDate, videoDate);

        if(diff.years() > 0){
            return `${Math.ceil(diff.years())} years ago`;

        }
        else if(diff.months() > 0){
            return `${Math.ceil(diff.months())} months ago`;
        }
        else{
            return `${Math.ceil(diff.days())} days ago`;
        }

        // console.log(diff.years(),diff.months(),diff.days());

    }

const VideoCard = ({video,sortBy})=>{

    
    return(
        <Box>
            <Link to={`/video/${video._id}`} style={{textDecoration:'none'}} className='video-tile-link'>
            <Card sx={{background:'#181818'}} className='video-tile'>
                <CardMedia
                        component="img"
                        height="153"
                        width="276"
                        sx={{ objectFit: "cover" }}
                        image={video.previewImage}
                        alt={video.title}
                />
                <CardContent>
                    <Typography variant="p" className='video-title'>
                        {video.title}
                    </Typography>
                    <Typography variant="p" component='div' className='video-subtitle'>
                        {sortBy==='releaseDate' ? formatTime(video.releaseDate) : `${video.viewCount}M views`}
                    </Typography>
                </CardContent>
                
            </Card>
            </Link>
        </Box>
    )
}

export default VideoCard